<template>
    <v-dialog v-model="dialogEditShow" max-width="600px">
      <v-card class="pa-4 pa-sm-8">
        <v-btn class="button-close ma-4" icon @click="dialogEditShow = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <h2 class="text-center">Промокод для распространения</h2>
        <form @submit.prevent="save" class="mt-6">
          <div class="container">
                    <v-select  v-model="curCode" :items="filteredCodes"
                      label="Промокод"
                      :item-text="(item) => item.title"
                      item-value="id"
                      outlined dense
                      :disabled="!$store.getters['auth/isAllowed']('change_partner_of_corpclient')"
                    />
          </div>

          <div class="row mt-3">
            <div class="col-md-6 mx-auto">
              <v-btn type="submit" class="w-100" color="primary" :loading="loading" :disabled="!curCode || loading">
                Добавить
              </v-btn>
            </div>
          </div>
        </form>
      </v-card>
    </v-dialog>
</template>

<script>
/*eslint-disable*/

import { mapActions, mapGetters } from 'vuex';
import api from '@/common/api';

export default {
  model: {
      prop: 'value',
      event: 'input'
  },
  props: {
    value: Boolean,
    client: Object,
    partnerId: Number,
    existingCodes: Array,
  },
  data: () => ({
    codes: [],
    curCode: null,
    loading: false,
  }),
  watch: {
    async dialogEditShow(newVal) {
      if (newVal) {
          await this.load();
      }
    },
  },
  computed: {
    ...mapGetters({
    }),
    dialogEditShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', false);
      }
    },
    filteredCodes() {
      return this.codes
        .filter(el => el.status !== 'expired')
        .filter(el => !this.existingCodes.find(item => item.id === el.id))
        .sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
    }
  },
  methods: {
    ...mapActions({
    }),
    async load() {
      try {
        this.codes = await api.post(`/users/partners/${this.partnerId}/get-promocodes/`);
        this.curCode = this.filteredCodes.find(el => el.is_default)
        if (!this.curCode && this.filteredCodes.length)
          this.curCode = this.filteredCodes[0];
        if (this.curCode)
          this.curCode = this.curCode.id
      } catch (err) {
        this.$toast.error("Ошибка при загрузке промокодов", '', { position: 'topRight' });
      }
    },
    async save() {
      try {
        this.loading = true;
        console.log({ promocode: this.curCode });
        const response = await api.post(`/users/corp_clients/${this.client.id}/promocodes/`, { promocode: this.curCode });
        console.log(response);
        if (response) {
          this.dialogEditShow = false;
          this.$emit('ok');
        }
      } catch (err) {
        let msg = "Ошибка при добавлении промокода"
        if (err.data?.error)
          msg += ': ' + err.data?.error;
        this.$toast.error(msg, '', { position: 'topRight' });
        console.log(err);
      } finally {
        this.loading = false;
      }

    },
  },
};

</script>
